













import { Component, Vue, Prop } from 'vue-property-decorator';
import { IExpiredCert, Route } from './types';

@Component
export default class ExpiredCert extends Vue implements IExpiredCert {
  @Prop({ type: Object, default: null })
  readonly to!: Route;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/components/expiredcert/ExpiredCert.vue